// extracted by mini-css-extract-plugin
export default {"sub_header_info":"sub-header-info_sub_header_info__Jgy2l","icon_img":"sub-header-info_icon_img__ucQm2","text_info":"sub-header-info_text_info__1Mgy+"};